<template>
  <progress class="progress pa-reward-progress" :class="additionalClass" :value="currentValue" :max="maxValue"></progress>
</template>

<script>
export default {
  props : {
    additionalClass : {
      default: function(){
        return {};
      }
    },

    currentValue  : {
      default: 0
    },

    maxValue  : {
      default: 0
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

progress.progress{
  &.pa-reward-progress{
    border-radius: 0;
    height:.4rem;
    color:#D89B21;
    margin-bottom:0;

    &[value]::-webkit-progress-value {
      transition: width 0.5s;
      transition-timing-function: ease-in-out;
    }

    &::-moz-progress-bar {
      background: #D89B21;
    }

    &::-webkit-progress-value {
      background: #D89B21;
    }

    &::-webkit-progress-bar {
      background: #494949;
    }

    @include from($desktop) {
      height:5px;
      margin:3px 0 0;
      border-radius: 2.5px;

      &::-webkit-progress-bar,
      &::-webkit-progress-value,
      &::-moz-progress-bar {
        border: 0;
        height: 5px;
        border-radius: 2.5px;
      }
    }

    &-park{
      color:#ba19c0;

      &::-moz-progress-bar {
        background: #ba19c0;
      }

      &::-webkit-progress-value {
        background: #ba19c0;
      }
    }
  }
}
</style>